import {
  AddBusinessOutlined,
  AddLocationAltOutlined,
  BlockOutlined,
  DirectionsBoatOutlined,
  FlagOutlined,
  LinkOutlined,
  VpnKeyOutlined,
} from '@mui/icons-material';
import {
  Box,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useState } from 'react';
import CountryAndPortsSection from '../sections/CountryAndPortsSection';
import HoldSection from '../sections/HoldSection';
import MarketSection from '../sections/MarketSection';
import ShipSection from '../sections/ShipSection';
import SupplierSection from '../sections/SupplierSection';
import CarrierSupplierMapSection from '../sections/CarrierSupplierMapSection';
import ApiKeySection from '../sections/ApiKeySection';

const SUBSECTIONS = [
  { key: 'CountryAndPorts', label: 'Country and Ports', icon: FlagOutlined },
  { key: 'Market', label: 'Market', icon: AddLocationAltOutlined },
  { key: 'Supplier', label: 'Supplier', icon: AddBusinessOutlined },
  { key: 'Ship', label: 'Ship', icon: DirectionsBoatOutlined },
  { key: 'Hold', label: 'Hold', icon: BlockOutlined },
  {
    key: 'CarrierSupplierMap',
    label: 'Carrier ID / Supplier ID Mapping',
    icon: LinkOutlined,
  },
  { key: 'ApiKeys', label: 'API Keys', icon: VpnKeyOutlined },
];

const SECTION_COMPONENTS = {
  CountryAndPorts: CountryAndPortsSection,
  Market: MarketSection,
  Supplier: SupplierSection,
  Ship: ShipSection,
  Hold: HoldSection,
  CarrierSupplierMap: CarrierSupplierMapSection,
  ApiKeys: ApiKeySection,
};

const MasterDataTab = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [activeSection, setActiveSection] = useState('CountryAndPorts');

  const ActiveComponent = SECTION_COMPONENTS[activeSection];

  return (
    <>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        mb={2}
        width='100%'
      >
        <Paper
          elevation={1}
          sx={{
            borderRadius: '6px',
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            padding: 2,
            overflow: 'hidden',
          }}
        >
          {!isSmallScreen && (
            <Typography variant='h3' sx={{ marginRight: 2, flexShrink: 0 }}>
              Subsections
            </Typography>
          )}
          <Box
            display='flex'
            flexWrap='wrap'
            justifyContent='center'
            alignItems='center'
            width='100%'
          >
            {SUBSECTIONS.map(({ key, label, icon: Icon }) => (
              <IconButton
                key={key}
                sx={{
                  paddingLeft: 2,
                  color: activeSection === key ? 'primary.main' : 'inherit',
                }}
                onClick={() => setActiveSection(key)}
              >
                <Icon />
                <Typography variant='body2'>{label}</Typography>
              </IconButton>
            ))}
          </Box>
        </Paper>
      </Box>
      {ActiveComponent && <ActiveComponent />}
    </>
  );
};

export default MasterDataTab;
